import * as types from '../types'
// state
const defaultState = {
  condition: {
    search: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  }
}

const state = JSON.parse(JSON.stringify(defaultState))

const mutations = {
  [types.SetStoreTable](state, {
    table,
    condition
  }) {
    state.condition = Object.assign({}, condition)
    state.table = Object.assign({}, table)
  },
  [types.InitStoreTable](state) {
    state.condition = Object.assign({}, defaultState.condition)
    state.table = Object.assign({}, defaultState.table)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stores.js